import { isMobile } from '../../scripts/helpers';
import Modal from '../Modal';

export default class CardLoadMore {
  constructor() {
    var cardsLoad = document.querySelectorAll('.card--load-more');

    if(typeof(cardsLoad) != 'undefined' && cardsLoad != null) {
      cardsLoad.forEach(element => {
        element.addEventListener('click', function(e) {
          e.preventDefault();
  
          if(!isMobile()) {
            var html = `
              <div class="card card--magazine">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--magazine.jpg" alt="Julho 2020">
                  </div>

                  <div class="card__content">
                    <p class="card__edition fs-12 fw-sb text-left">Proteste 201</p>
                    <p class="card__title fs-18 text-left">Julho 2020</p>
                  </div>
                </a>
              </div>
              <div class="card card--magazine">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--magazine.jpg" alt="Julho 2020">
                  </div>

                  <div class="card__content">
                    <p class="card__edition fs-12 fw-sb text-left">Proteste 201</p>
                    <p class="card__title fs-18 text-left">Julho 2020</p>
                  </div>
                </a>
              </div>
              <div class="card card--magazine">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--magazine.jpg" alt="Julho 2020">
                  </div>

                  <div class="card__content">
                    <p class="card__edition fs-12 fw-sb text-left">Proteste 201</p>
                    <p class="card__title fs-18 text-left">Julho 2020</p>
                  </div>
                </a>
              </div>
              <div class="card card--magazine">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--magazine.jpg" alt="Julho 2020">
                  </div>

                  <div class="card__content">
                    <p class="card__edition fs-12 fw-sb text-left">Proteste 201</p>
                    <p class="card__title fs-18 text-left">Julho 2020</p>
                  </div>
                </a>
              </div>
              `;
  
            this.parentNode.insertAdjacentHTML("afterbegin", html);
          } else {
            var html = `
              <div class="card card--magazine">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--magazine.jpg" alt="Julho 2020">
                  </div>

                  <div class="card__content">
                    <p class="card__edition fs-12 fw-sb text-left">Proteste 201</p>
                    <p class="card__title fs-18 text-left">Julho 2020</p>
                  </div>
                </a>
              </div>
              <div class="card card--magazine">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--magazine.jpg" alt="Julho 2020">
                  </div>

                  <div class="card__content">
                    <p class="card__edition fs-12 fw-sb text-left">Proteste 201</p>
                    <p class="card__title fs-18 text-left">Julho 2020</p>
                  </div>
                </a>
              </div>
              <div class="card card--magazine">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--magazine.jpg" alt="Julho 2020">
                  </div>

                  <div class="card__content">
                    <p class="card__edition fs-12 fw-sb text-left">Proteste 201</p>
                    <p class="card__title fs-18 text-left">Julho 2020</p>
                  </div>
                </a>
              </div>
              <div class="card card--magazine">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--magazine.jpg" alt="Julho 2020">
                  </div>

                  <div class="card__content">
                    <p class="card__edition fs-12 fw-sb text-left">Proteste 201</p>
                    <p class="card__title fs-18 text-left">Julho 2020</p>
                  </div>
                </a>
              </div>
              `;
  
            this.parentNode.insertAdjacentHTML("afterbegin", html);

            const offsetTop = document.querySelector(".benefit").offsetTop;
            scroll({
              top: offsetTop,
              behavior: "smooth"
            });
          }
        });
      });
    }

    var cardCarouselMagazine = document.querySelectorAll('.card__carousel--magazine');

    if(typeof(cardCarouselMagazine) != 'undefined' && cardCarouselMagazine != null) {
      if(!isMobile()) {
        $('.card__carousel--magazine').slick({
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        });
      }
    }

    var cardCarouselDiscount = document.querySelectorAll('.card__carousel--discount');

    if(typeof(cardCarouselDiscount) != 'undefined' && cardCarouselDiscount != null) {
      if(!isMobile()) {
        $('.card__carousel--discount').slick({
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
        });
      }
    }

    var cardBenefitClub = document.querySelector('.card--discount__button');

    

    if(typeof(cardBenefitClub) != 'undefined' && cardBenefitClub != null) {
        
        cardBenefitClub.addEventListener('click', function(e) {
          e.preventDefault();

          var html = `
            <div class="card card--discount" data-modal-open="benefit-club-aninhare">
              <a href="#" class="card__wrapper">
                <div class="card__image">
                  <img src="/public/ico-aninhare.png" alt="Desconto">
                </div>
              
                <div class="card__content">
                  <p class="card__discount">50%</p>
                  <p class="card__title">de desconto em cursor<br/>online</p>
                </div>
              </a>
            </div>
            
            <div class="card card--discount" data-modal-open="benefit-club">
              <a href="#" class="card__wrapper">
                <div class="card__image">
                  <img src="/public/ico-rappi.png" alt="Desconto">
                </div>
              
                <div class="card__content">
                  <p class="card__discount">R$150</p>
                  <p class="card__title">em créditos</p>
                </div>
              </a>
            </div>
              `;
  
            this.parentNode.insertAdjacentHTML("afterbegin", html);

            const offsetTop = document.querySelector(".benefit__discount-list").offsetTop;
            scroll({
              top: offsetTop,
              behavior: "smooth"
            });

            new Modal();
        });
     }
  }
};

const cardLoad = new CardLoadMore();